exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "span#hidden-date-html5 {\n  position: relative; }\n\ninput.hidden-date {\n  position: absolute;\n  opacity: 0;\n  z-index: 1; }\n\ninput.hidden-date::-webkit-calendar-picker-indicator {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0; }\n\ninput.hidden-date:hover + button {\n  background-color: silver; }\n", ""]);

